import { useState } from 'react';
import { fetchGitTeams } from 'common/services/git-teams.service';
import useToast from 'components/hooks/useToast';
import {
  ProviderTeamUI,
  UseProviderTeamsProps,
  UseProviderTeamsResponse
} from './useProviderTeams.types';

const useProviderTeamsPaginated = ({
  sensorAuthId,
  orgName
}: UseProviderTeamsProps): UseProviderTeamsResponse => {
  const toast = useToast();
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [providerTeams, setProviderTeams] = useState<ProviderTeamUI[]>([]);

  const loadProviderTeams = async () => {
    try {
      setProviderTeams([]);
      setIsLoading(true);
      const gitTeams: any = await fetchGitTeams({ sensorAuthId, orgName });
      setProviderTeams(gitTeams);
    } catch (e) {
      setProviderTeams([]);
      toast({
        message: `Failed to fetch ${orgName} teams at the moment, please try again later.`,
        variant: 'error'
      });
    } finally {
      setIsLoading(false);
    }
  };

  return {
    providerTeams,
    loadProviderTeams,
    isLoading
  };
};

export default useProviderTeamsPaginated;
